export type PageSize = 'A4' | 'Letter';

export type PageOrientation = 'portrait' | 'landscape';

export function getPageDimensions(
  size: PageSize,
  orientation: PageOrientation = 'portrait'
): {
  widthMm: number;
  heightMm: number;
} {
  const base =
    size === 'A4'
      ? { widthMm: 210, heightMm: 297 }
      : // US Letter: 8.5 x 11 in
        // 8.5in = 21.59cm = 215.9mm; 11in = 27.94cm = 279.4mm
        { widthMm: 215.9, heightMm: 279.4 };

  if (orientation === 'portrait') return base;

  return {
    widthMm: base.heightMm,
    heightMm: base.widthMm
  };
}
